// Копипаст из https://gist.github.com/tomfun/830fa6d8030d16007bbab50a5b21ef97
export function getPluralNoun(number: number, one: string, two: string, five: string) {
  const absoluteNumber = Math.abs(number);

  if (absoluteNumber % 100 >= 5 && absoluteNumber % 100 <= 20) {
    return five;
  }
  if (absoluteNumber % 10 === 1) {
    return one;
  }
  if (absoluteNumber >= 2 && absoluteNumber <= 4) {
    return two;
  }

  return five;
}
